import { change } from 'redux-form';

import { loading, handleErrorException, success } from 'State/actions';
import { ITEM_LISTING_FORM_NAME } from 'Common/FormEnum';
import { ItemListingReportEnum } from 'Common/FieldEnum';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

import * as types from './types';

export const getItemList = requestObj => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ITEM_DATA_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        `ItemListing/GetItemListing`,
        requestObj
      );
      dispatch(
        success(
          types.ITEM_LIST_DATA,
          response.data.Data.Data ? response.data.Data.Data : []
        )
      );
    } catch (err) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: 'An error occurred while fetching items. Please try again.',
      };
      dispatch(
        handleErrorException(err, types.ITEM_DATA_LIST_ERROR, defaultError)
      );
    } finally {
      dispatch(loading(types.ITEM_DATA_LOADING, false));
    }
  };
};

export const setItemsIds = values => {
  return change(
    ITEM_LISTING_FORM_NAME,
    ItemListingReportEnum.ItemListInfo,
    values
  );
};



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/itemlistingreport/state/actions.js